import {Injectable} from '@angular/core';
import {AuthApiService} from '../Api/Auth/auth-api.service';
import {UserSessionDto} from '../../Models/User/user-session.interface';

@Injectable({
  providedIn: 'root'
})
export class PermissionsManagerService {

  constructor(
    private readonly userSession: AuthApiService,
  ) {
  }


  /**
   * Comprobar permiso
   *
   */
  public checkPermission(module: string, permission: string, defaultValue: boolean = false): boolean {
    const user: UserSessionDto | null = this.userSession.getUserSession();

    if (!user || !module || !permission) {
      return false;
    }

    return user?.permisos?.application?.[module]?.[permission] ?? defaultValue;
  }


  /**
   * Comprobar configuración del usuario
   *
   */
  public checkConfig<T extends boolean | string | number>(key: string, defaultValue: T): T {
    const user: UserSessionDto | null = this.userSession.getUserSession();

    if (!user || !key) {
      return defaultValue;
    }

    const config = user.config?.find((item) => item.key === key);

    if (!config || config.expired) {
      return defaultValue;
    }

    return config.value as T;
  }


  /**
   * Comprobar si el usuario pertenece al cliente
   *
   */
  public checkActionClient(client: number): boolean {
    const user: UserSessionDto | null = this.userSession.getUserSession();

    if (!user || !client) {
      return false;
    }

    return user.id_cliente === client;
  }

}
